module.exports = new __parcel__URL__("dragon-statue.69c47771.webp").toString();